export default "__VITE_ASSET__CQeV0bt7__"